import { useMemo } from "react"
import { useSelector } from "react-redux"
//check if the user is in adesk
const useActiveCompanyAdesk = () => {
  const currentCompany = useSelector(state => state.companies.activeCompany)
  return useMemo(
    () => {
      return currentCompany === 2
    },
    [currentCompany]
  )
}

export default useActiveCompanyAdesk
